import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('targetedIabCategories',  {
    bindings: {
      formName: '@',
      formId: '@',
      allowList: '@',
      iabSource: '@',
      selectedLists: '<',
      selectedCategoryCodes: '<',
      categoryOptions: '<'
    },
    template: require("../templates/targetedIabCategories.html"),
    controllerAs: '$targetedIabCategoriesCtrl',
    controller: function() {
      this.allowlistButtonOptions = componentHelper.targetingOptions();
      this.targetingSourceOptions = componentHelper.targetingSourceOptions();
    }
});
